const SIDANG_TYPE = {
  "Tugas Akhir Individu": "Tugas Akhir Individu",
  "Tugas Akhir Kelompok": "Tugas Akhir Kelompok",
  "Karya Akhir": "Karya Akhir",
  "Proposal Tesis": "Proposal Tesis",
  Tesis: "Tesis",
  "Wawancara Calon S3": "Wawancara Calon S3",
  "Usulan Penelitian": "Usulan Penelitian",
  "Seminar Hasil Penelitian S3": "Seminar Hasil Penelitian S3",
  "Pra-Promosi": "Pra-Promosi",
  Promosi: "Promosi",
};

const SIDANG_TYPE_WITH_JENJANG = {
  "Tugas Akhir Individu": "S1 - Tugas Akhir Individu",
  "Tugas Akhir Kelompok": "S1 - Tugas Akhir Kelompok",
  "Karya Akhir": "MTI - Karya Akhir",
  "Proposal Tesis": "MIK - Proposal Tesis",
  Tesis: "MIK - Tesis",
  "Wawancara Calon S3": "DIK - Wawancara Calon S3",
  "Usulan Penelitian": "DIK - Usulan Penelitian",
  "Seminar Hasil Penelitian S3": "DIK - Seminar Hasil Penelitian S3",
  "Pra-Promosi": "DIK - Pra-Promosi",
  Promosi: "DIK - Promosi",
};

const SIDANG_S1_TYPE = {
  ta_individu: "Tugas Akhir Individu",
  ta_kelompok: "Tugas Akhir Kelompok",
};

const SIDANG_S2_TYPE = {
  karya_akhir: "Karya Akhir",
  proposal: "Proposal",
  tesis: "Tesis",
};

const SIDANG_S3_TYPE = {
  wawancara_calon: "Wawancara Calon",
  usulan_penelitian: "Usulan Penelitian",
  seminar_hasil_penelitian: "Seminar Hasil Penelitian",
  pra_promosi: "Pra-Promosi",
  promosi: "Promosi",
};

const SIDANG_S3_TYPE_WITH_STRING_KEY = {
  "Wawancara Calon S3": "Wawancara Calon S3",
  "Usulan Penelitian": "Usulan Penelitian",
  "Seminar Hasil Penelitian S3": "Seminar Hasil Penelitian S3",
  "Pra-Promosi": "Pra-Promosi",
  Promosi: "Promosi",
};

export {
  SIDANG_TYPE,
  SIDANG_TYPE_WITH_JENJANG,
  SIDANG_S1_TYPE,
  SIDANG_S2_TYPE,
  SIDANG_S3_TYPE,
  SIDANG_S3_TYPE_WITH_STRING_KEY,
};
